export class Transition {
  constructor({ wrapper }) {
    this.wrapper = wrapper
  }

  leave(props) {
    return new Promise((resolve) => {
      this.onLeave({ ...props, done: resolve })
    })
  }

  enter(props) {
    return new Promise((resolve) => {
      this.onEnter({ ...props, done: resolve })
    })
  }

  onLeave({ from, trigger, done }) {
    done()
  }

  onEnter({ to, trigger, done }) {
    done()
  }
}
